import { Typography } from '@la/ds-ui-components';
import { Activity } from '@la/types';

export default function ActivityAttendance({
  activity,
}: {
  activity?: Activity;
}) {
  return (
    <Typography variant="ui" size="large" weight="bold">
      Attendance
    </Typography>
  );
}
